module.exports = __webpack_public_path__ + "static/events-a47b9023b8382bb503caaf8f8f31acd0.jpg";